import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/functions/analytics";

export function usePageViewTracking(): void {
  const location = useLocation();
  const prevPathname = useRef(location.pathname);

  useEffect(() => {
    if (location.pathname !== prevPathname.current) {
      trackPageView(location.pathname + location.search);
      prevPathname.current = location.pathname;
    }
  }, [location]);
}
